import { connect } from 'react-redux';
import {
  selectCurrentCoursePath,
  selectCurrentCourseHasLoaded,
} from '../../../../ReduxStorage/Courses/selectors';
import { CourseAppearanceSettings } from './component';
import { setCourseThemeData } from '../../../../ReduxStorage/Courses/dispatchers';
import {
  selectCurrentCourseIsUsingPortalTheme,
  selectCurrentPortalCourseTheme,
} from '../../../../ReduxStorage/CourseTheme/selectors';
import { setCourseAppearanceSettingsPreview } from '../../../../ReduxStorage/CourseAppearanceSettings/dispatchers';
import { sendUserpilotTracking } from '../../../../ReduxStorage/Userpilot/dispatchers';

export const ConnectedCourseAppearanceSettings = connect(
  (state) => ({
    path: selectCurrentCoursePath(state),
    themeData: selectCurrentPortalCourseTheme(state),
    isUsingPortalTheme: selectCurrentCourseIsUsingPortalTheme(state),
    currentCourseHasLoaded: selectCurrentCourseHasLoaded(state),
  }),
  (dispatch) => ({
    setCourseThemeData: ({ path, themeDataChanges }) =>
      dispatch(setCourseThemeData(path, themeDataChanges)),
    setCourseThemeDataPreview: ({ themeDataChanges }) =>
      dispatch(setCourseAppearanceSettingsPreview(themeDataChanges)),
    sendUserpilotTracking: (event) => dispatch(sendUserpilotTracking(event)),
  })
)(CourseAppearanceSettings);
